module.exports = __webpack_public_path__ + "static/fonts/Fact-ExtraLightItalic.82986b8.eot";